import React, { useEffect } from "react";
import { useStore } from "react-redux";
import common from "../resources/js/common/common";
import { getEnvParam } from '../const/index.js';

export const useRtoaster = (url, customParam) => {
  const store = useStore();
  const envParam = store.getState().envParam;

  useEffect(() => {
    if(envParam && envParam.rtoasterEnvParam){
      insertTag(envParam);
      return;
    }
    common.doPost(getEnvParam, {}, afterGetEnvParam);
  }, []);

  const afterGetEnvParam = (res) => {
    if (res.data.resultCode == 0) {
      const envParam = res.data.envParam;
      store.dispatch({ type:"ENV_PARAM", payload: {envParam: res.data.envParam} });
      if(envParam.rtoasterEnvParam){
        insertTag(envParam);
      }
    }
  }

  const insertTag = (envParam) => {
    const head = document.getElementsByTagName("head")[0];
    const removeTarget = document.getElementById("rtoasterTag");
    if (removeTarget) {
      head.removeChild(removeTarget);
    }
    const scriptUrl = document.createElement("script");
    scriptUrl.type = "text/javascript";
    scriptUrl.id = "rtoasterTag";
    let scriptTrack = "";
    if (url && customParam) {
      scriptTrack = `Rtoaster.track("${url}", ${JSON.stringify(customParam)})`
    } else {
      scriptTrack = `Rtoaster.track()`
    }
    let scriptContents = "";
    if (envParam.rtMemberId){
      scriptContents = document.createTextNode(`Rtoaster.init("${envParam.rtoasterEnvParam}", "${envParam.rtMemberId}"); ${scriptTrack};`);
    } else {
      scriptContents = document.createTextNode(`Rtoaster.init("${envParam.rtoasterEnvParam}"); ${scriptTrack};`);
    }
    scriptUrl.appendChild(scriptContents);
    head.appendChild(scriptUrl);
  }
};